// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import WeeklyTimesheet from "@/pages/WeeklyTimesheet";
import AdminDashboard from "@/pages/AdminDashboard";
import UserManagement from "@/pages/UserManagement";
import LeaveManagement from "@/pages/LeaveManagement";
import { ThemeProvider } from "@/components/ThemeProvider";
import { Toaster } from "@/components/ui/toaster";  // Import Shadcn's Toaster

import '@/styles/globals.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <ThemeProvider defaultTheme="system">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <BrowserRouter>
            <AuthProvider>
              
                <Routes>
                  {/* Public Routes */}
                  <Route path="/login" element={<Login />} />

                  {/* Protected Routes */}
                  <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                    {/* Admin Routes */}
                    <Route
                      path="/admin/dashboard"
                      element={
                        <ProtectedRoute requiredRole="admin">
                          <AdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/users"
                      element={
                        <ProtectedRoute requiredRole="admin">
                          <UserManagement />
                        </ProtectedRoute>
                      }
                    />

                    {/* User Routes */}
                    <Route path="/weeklytimesheet" element={<WeeklyTimesheet />} />
                    <Route path="/timesheet" element={<WeeklyTimesheet />} />
                    <Route path="/leave" element={<LeaveManagement />} />
                    <Route path="/leavemanagement" element={<LeaveManagement />} /> {/* This is correct! */}

                    {/* Default Route */}
                    <Route path="/" element={<Navigate to="/weeklytimesheet" replace />} />
                    <Route path="*" element={<Navigate to="/weeklytimesheet" replace />} />
                  </Route>
                </Routes>
             
            </AuthProvider>
          </BrowserRouter>
          <Toaster /> {/* Replace ToastProvider with Shadcn's Toaster */}
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;